
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/aesthetic",
      function () {
        return require("private-next-pages/learn/aesthetic/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/aesthetic"])
      });
    }
  